export default "__VITE_ASSET__84ccdb04__"